import { encryptSSNWithPublicKeyBase64 } from '../../services/ssnCrypto';

const isPlainTaxId = (value) => {
    if (value === null || value === undefined) {
        return false;
    }

    const rawValue = String(value).trim();
    const digits = rawValue.replace(/\D/g, '');

    return /^[\d\s-]+$/.test(rawValue) && /^\d{9}$/.test(digits);
};

export async function encryptOnlineCartAnswersForService(answers = {}) {
    if (!answers || typeof answers !== 'object' || Array.isArray(answers)) {
        return answers;
    }

    if (!isPlainTaxId(answers.ssnFull)) {
        return answers;
    }

    const encryptedSSN = await encryptSSNWithPublicKeyBase64(
        answers.ssnFull,
        process.env.REACT_APP_SSN_PUBLIC_KEY_BASE64
    );

    return {
        ...answers,
        ssnFull: encryptedSSN,
    };
}

export async function encryptOnlineCartRecordForService(record = {}) {
    if (!record || typeof record !== 'object' || Array.isArray(record)) {
        return record;
    }

    const encryptedAnswers = await encryptOnlineCartAnswersForService(record.answers);

    if (encryptedAnswers === record.answers) {
        return record;
    }

    return {
        ...record,
        answers: encryptedAnswers,
    };
}
